import { en } from "./en";

export const pl = en;
